import React from "react"

interface Props {
  isMobile: boolean
}

export default function PlusCircleIcon({ isMobile }: Props) {
  return (
    <>
      {isMobile ? (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="16" cy="16" r="15" fill="#2962FF" stroke="#D8DEEE" strokeWidth="2" />
          <path
            d="M23.3638 17.8638H23.8638V17.3638V15.3638V14.8638H23.3638H17.8638V9.36377V8.86377H17.3638H15.3638H14.8638V9.36377V14.8638H9.36377H8.86377V15.3638V17.3638V17.8638H9.36377H14.8638V23.3638V23.8638H15.3638H17.3638H17.8638V23.3638V17.8638H23.3638Z"
            fill="white"
            stroke="white"
          />
        </svg>
      ) : (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24" cy="24" r="23" fill="#2962FF" stroke="#D8DEEE" strokeWidth="2" />
          <path
            d="M35.0454 26.5454H35.5454V26.0454V23.0454V22.5454H35.0454H26.5454V14.0454V13.5454H26.0454H23.0454H22.5454V14.0454V22.5454H14.0454H13.5454V23.0454V26.0454V26.5454H14.0454H22.5454V35.0454V35.5454H23.0454H26.0454H26.5454V35.0454V26.5454H35.0454Z"
            fill="white"
            stroke="white"
          />
        </svg>
      )}
    </>
  )
}
